import {Validators} from '@angular/forms';

import {ComponentTypesEnum} from '../../../app/shared/enums';
import {DialogButtonTypesEnum, DialogConfigInterface} from '../../../app/shared/components';
import {AmountControl, AutocompleteControl, BaseControl} from '../../../app/shared/classes';

export const DepositLinkedAccountFromSelector = 'linkedAccountFrom';
export const DepositAccountFromSelector = 'accountFrom';
export const DepositAccountToSelector = 'accountTo';
export const DepositAmountSelector = 'amount';

export const DepositComponentControls = (): BaseControl<string | number>[] => {
    return [
        new AutocompleteControl({
            name: DepositLinkedAccountFromSelector,
            value: null,
            placeholder: 'Account From',
            validators: [Validators.required],
            componentType: ComponentTypesEnum.Autocomplete,
            options: []
        }),
        new AutocompleteControl({
            name: DepositAccountFromSelector,
            value: null,
            placeholder: 'Account From',
            validators: [Validators.required],
            componentType: ComponentTypesEnum.Autocomplete,
            options: []
        }),
        new BaseControl({
            name: DepositAccountToSelector,
            value: null,
            placeholder: 'Account To',
            validators: [Validators.required],
            componentType: ComponentTypesEnum.Text,
            readonly: true
        }),
        new AmountControl({
            name: DepositAmountSelector,
            value: null,
            placeholder: 'Amount',
            validators: [Validators.required],
            componentType: ComponentTypesEnum.AmountInput,
            currency: 'USD'
        })
    ];
};

export const DepositDialogConfig = (): DialogConfigInterface => {
    return {
        process: {
            loading: false,
            finished: false,
            failed: false,
            failedMessage: '',
            succeedMessage: ''
        },
        buttons: [
            {
                type: DialogButtonTypesEnum.Cancel
            },
            {
                type: DialogButtonTypesEnum.Confirm
            }
        ],
        buttonsDisabled: false,
        buttonsHidden: true
    };
};
